module.exports = __webpack_public_path__ + "img/dnsc_logo.12811345.png";